import React, { Fragment } from 'react';
import { formatDate, formatCNPJ } from 'utils/formatDate';
import { maskCPF } from 'utils/formatters';
import { ContractingType } from 'v3/data/store/contracting/types';
import {
  AlignClientInfo,
  AlignValues,
  BodyLine,
  HeaderLine,
  Line,
  MainContainer,
  SubtitleLine,
} from '../styles';
import { PixRounded } from '@mui/icons-material';
import { TextButton } from 'v3/shared/components/Button/TextButton';

interface IMobileTable {
  contractingList: ContractingType[];
  handleOpenSellerVerificationModal: (contractingKey: string) => void;
}

export const PaymentsMobileTable: React.FC<IMobileTable> = ({ contractingList, handleOpenSellerVerificationModal }) => {

  return (
    <Fragment>
      {contractingList.map((contracting) => {
        const { fullName, cpf } = contracting.person;
        const { name } = contracting.creditSimulation.store;
        const formattedCNPJ = formatCNPJ(contracting.creditSimulation.store.cnpj);
        const { date, time } = formatDate(contracting.createdAt);
        const formattedCPF = maskCPF(cpf);

        return (
          <MainContainer
            key={contracting.contractingKey}
          >
            <AlignValues>
              <HeaderLine>Cliente</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{fullName}</BodyLine>
                <SubtitleLine>{formattedCPF}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Loja</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{name}</BodyLine>
                <SubtitleLine>{formattedCNPJ}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Data e hora</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{date}</BodyLine>
                <SubtitleLine>{time}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            <Line />
            <TextButton
              text="Pagar com Pix"
              $outline={true}
              startIcon={PixRounded}
              size='small'
              handleClick={() => {
                handleOpenSellerVerificationModal(contracting.contractingKey);
              }}
            />
          </MainContainer>
        );
      })}
    </Fragment>
  );
};